<template>
    <div>
        <vs-row v-if="cards">
            <vs-col  v-if="cards.total_alumnos" sm="12" lg="3" class="p-1">
                <div class="card md-warn">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.total_alumnos}}</strong></h4>
                        <p class="mb-0"><strong>Total</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.grado_en_ciclo" :key="key">
                <div class="card md-green" v-if="cards.grado_en_ciclo">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Grado</small></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.programa_en_ciclo" :key="key">
                <div class="card md-purple" v-if="cards.programa_en_ciclo">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Programa</small></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.status_global" :key="key">
                <div class="card md-blue" v-if="cards.status_global">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Estatus</small></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <vs-button
            v-if="users != ''"
            color="#55ce63"
            relief
            :loading="loadingExcel"
            @click="getExcel()"
            class="ml-auto"
        >
            <i class="fas fa-download mr-2"></i> Descargar reporte
        </vs-button>
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped v-dragscroll="{ target: '.vs-table', active: true }">
            <template #thead>
                <vs-tr>
                    <vs-th>
                        Alumno
                    </vs-th>
                    <vs-th>
                        Académico
                    </vs-th>
                    <vs-th>
                        Referencia SIM
                    </vs-th>
                    <vs-th>
                        CURP
                    </vs-th>
                    <vs-th>
                        Correo institucional
                    </vs-th>
                    <vs-th>
                        Padre
                    </vs-th>
                    <vs-th>
                        Madre
                    </vs-th>
                    <vs-th>
                        Otro
                    </vs-th>
                    <vs-th>
                        Correo registrado en prospecto
                    </vs-th>
                    <vs-th>
                        Acción
                    </vs-th>
                    <vs-th></vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in $vs.getSearch(users, search)"
                    :data="tr"
                    style="border-bottom: 1px solid #D7DBDD;"
                >
                    <vs-td>
                        <md-content class="docientos">
                            <div class="estatus-alumno" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                            </div>
                            <p class="mb-0"><strong>{{ tr.fullName }}</strong></p>
                            <p class="mb-0"><small><strong>MATRÍCULA</strong></small></p>
                            <p class="mb-0">{{ tr.matricula }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-0 text-uppercase"><small><strong>Estatus global</strong></small></p>
                            <p class="mb-1">{{ tr.status_global }}</p>
                            <p class="mb-0 text-uppercase"><small><strong>Programa</strong></small></p>
                            <p class="mb-1">{{ tr.programa_en_ciclo }}</p>
                            <p class="mb-0 text-uppercase"><small><strong>Grado</strong></small></p>
                            <p class="mb-1">{{ tr.grado_en_ciclo }}</p>
                            <p class="mb-0 text-uppercase"><small><strong>Ciclo Escolar</strong></small></p>
                            <p class="mb-1">{{ tr.ciclo_escolar }}</p>
                            <p class="mb-0 text-uppercase"><small><strong>Grupo</strong></small></p>
                            <p class="mb-1" v-for="(grupo, i) in tr.grupos" :key="i">{{ grupo }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="cien">
                            <p class="mb-0">{{ tr.referencia_sim }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="cienCincuenta">
                            <p class="mb-1">{{ tr.curp }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-1">{{ tr.correo }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-0" v-if="tr.nombre_padre"><strong>{{ tr.nombre_padre }}</strong></p>
                            <p class="mb-1" v-if="tr.correo_padre">{{ tr.correo_padre }}</p>
                            <p class="mb-0 text-uppercase" v-if="tr.es_tutor_padre"><small><strong>Asignado como tutor</strong></small></p>
                            <p class="mb-1" v-if="tr.es_tutor_padre">{{ tr.es_tutor_padre }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-0" v-if="tr.nombre_madre"><strong>{{ tr.nombre_madre }}</strong></p>
                            <p class="mb-1" v-if="tr.correo_madre">{{ tr.correo_madre }}</p>
                            <p class="mb-0 text-uppercase" v-if="tr.es_tutor_madre"><small><strong>Asignado como tutor</strong></small></p>
                            <p class="mb-1" v-if="tr.es_tutor_madre">{{ tr.es_tutor_madre }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-0" v-if="tr.nombre_tutor"><strong>{{ tr.nombre_tutor }}</strong></p>
                            <p class="mb-1" v-if="tr.correo_otro">{{ tr.correo_otro }}</p>
                            <p class="mb-0 text-uppercase" v-if="tr.es_tutor_otro"><small><strong>Asignado como tutor</strong></small></p>
                            <p class="mb-1" v-if="tr.es_tutor_otro">{{ tr.es_tutor_otro }}</p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="docientos">
                            <p class="mb-0" v-if="tr.correo_prospecto"><strong>{{ tr.correo_prospecto }}</strong></p>
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="cien">
                            <vs-button
                                success
                                flat
                                blank
                                :href="`/panel/`+ tr.url + `/institucion/` + window.btoa(tr.institucionId)"
                            >
                                Ver perfil
                            </vs-button>
                        </md-content>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
      </vs-table>
    </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'users',
        'cards',
        'institucion',
        'grupo',
        'cicloEscolar',
        'header'
    ],
    data(){
        return{
            loadingExcel: false,
            search: '',
            estatusBaja: []
        }
    },
    directives: {
       'dragscroll': dragscroll
    },
    created(){
        this.getEstatusAlumno()
    },
    methods:{
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await alumnos.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            const vm = this
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(vm.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        getExcel () {
            this.loadingExcel = true
            let formData = {
                'institucion_id': this.institucion,
                'grupo_id': this.grupo,
                'ciclo_escolar_id': this.cicloEscolar
            }

            formData.headers = ['matricula', 'referencia_sim', 'apellido_paterno_alumno', 'apellido_materno_alumno', 'nombre_alumno', 'lugar_nacimiento', 'fecha_nacimiento',  'correo', 'curp', 'status_global', 'programa_en_ciclo', 'grado_en_ciclo', 'ciclo_escolar', 'grupos', 'correo_prospecto', 'correo_padre', 'correo_madre', 'correo_tutor', 'nombre_padre', 'es_tutor_padre', 'nombre_madre', 'es_tutor_madre', 'nombre_otro', 'es_tutor_otro']
            this.loading = true
            setTimeout(() => {
                axios.get('/reportes/file-alumnos-por-ciclo', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
    }
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .cien {
        width: 100px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        justify-content: center;
        align-items: center;

    }
</style>

<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-blue{
        background: #5DADE2;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }

    .md-brown{
        background: #784212;
        color: white;
        border-radius: 7px;
    }

    .md-pruple{
        background: purple;
        color: white;
        border-radius: 7px;
    }
</style>